import Toolbar from '@admin/components/toolbar'
import PropTypes from 'prop-types'
import React from 'react'

class Header extends React.PureComponent {

  static propTypes = {
    device: PropTypes.string,
    devices: PropTypes.array,
    orientation: PropTypes.string,
    onDevice: PropTypes.func,
    onOrientation: PropTypes.func
  }
  
  _handleDevice = this._handleDevice.bind(this)
  _handleOrientation = this._handleOrientation.bind(this)

  render() {
    return (
      <div className="maha-preview-header">
        <Toolbar { ...this._getToolbar() } />
      </div>
    )
  }

  _getToolbar() {
    const { device, devices, orientation } = this.props
    return {
      leftButtons: [],
      centerButtons: [
        ...devices.map(({ value, label }, index) => ({
          tooltip: label,
          active: value === device,
          label,
          handler: this._handleDevice.bind(this, value)
        })),
        {
          svg: 'smartphone',
          tooltip: 't(Orientation)',
          disabled: device === 'desktop',
          rotated: orientation === 'landscape',
          handler: this._handleOrientation
        }
      ],
      rightButtons: []
    }
  }

  _handleDevice(device) {
    this.props.onDevice(device)
  }

  _handleOrientation() {
    const orientation = this.props.orientation === 'landscape' ? 'portrait' : 'landscape'
    this.props.onOrientation(orientation)
  }

}

export default Header
